import React, { createContext, useContext, useEffect, useState } from "react";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";
import classes from "./Layout.module.css";
import settingsService from "../../services/settings";
import branchesService from "../../services/branches";
import servicesService from "../../services/services";
import informationPolicyService from "../../services/informationPolicy";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const LabReportContext = createContext();
export const useLabReport = () => useContext(LabReportContext);

export const Layout = ({ children }) => {
  const [branches, setBranches] = useState([]);
  const [branchesLoading, setBranchesLoading] = useState(false);
  const [services, setServices] = useState([]);
  const [servicesLoading, setServicesLoading] = useState(false);
  const [settings, setSettings] = useState();
  const [policies, setPolicies] = useState([]);
  console.log("settings in layout", settings);
  const location = useLocation();
  const { homeApis } = useSelector((state) => state.widget); // Access widget data

  const [showLabReportModal, setShowLabReportModal] = useState(false);
  console.log("home apis in layout", homeApis);

  // Scroll to top whenever the route changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const getSettings = async () => {
    const data = await settingsService.getAll();

    if (data?.data) {
      setSettings(data.data[0]);
    }
  };
  const getServices = async () => {
    setServicesLoading(true);
    const data = await servicesService.getAll();

    if (data) {
      setServices(data.data);
    }
    setServicesLoading(false);
  };

  const getBranches = async () => {
    setBranchesLoading(true);
    const data = await branchesService.getAll();

    if (data) {
      setBranches(data.data);
    }
    setBranchesLoading(false);
  };

  const getPolicies = async () => {
    const data = await informationPolicyService.getAll();

    if (data) {
      setPolicies(
        data.data?.filter((item) => item?.slug != "investors-and-relations")
      );
    }
  };

  // useEffect(() => {
  //   getSettings();
  //   getBranches();
  //   getServices();
  //   getPolicies();
  // }, []);
  return (
    <LabReportContext.Provider
      value={{ showLabReportModal, setShowLabReportModal }}
    >
      <div className={classes.appContainer}>
        <nav className={classes.navbarLayout}>
          <Navbar
            branches={homeApis?.branches}
            branchesLoading={branchesLoading}
            services={homeApis?.services}
            servicesLoading={servicesLoading}
            settings={homeApis?.adminSettings}
          />
        </nav>
        <main>{children}</main>
        <footer>
          <Footer
            settings={homeApis?.adminSettings}
            services={homeApis?.services}
            policies={homeApis?.informationPolicies}
          />
        </footer>
        <div id="footer-home"></div>
      </div>
    </LabReportContext.Provider>
  );
};
